// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-labels{width:14.791667rem}.my-label,.my-labels{text-align:right!important}.my-label{width:9.166667rem}.label_right{width:10.677083rem;text-align:right!important}", ""]);
// Exports
module.exports = exports;
